export const UrlKeys = Object.freeze({
    L2BSignInUp: 1,
    UnKnown: 0,
    L2BContact: 2,
    L2BAbout: 3
  })
  
  export default { UrlKeys };
  